import { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import SkeletonContainer from 'conversations-skeleton-state/components/SkeletonContainer';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { CRM_COLLAPSED_WIDTH, CRM_BREAK_POINT } from '../../crm-sidebar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CrmHeader = styled.div.withConfig({
  displayName: "ContactSidebarPlaceholder__CrmHeader",
  componentId: "m8eul1-0"
})(["display:flex;flex-direction:row;align-items:center;height:116px;padding:24px;border-bottom:1px solid ", ";"], GREAT_WHITE);
const CollapsedCard = styled.div.withConfig({
  displayName: "ContactSidebarPlaceholder__CollapsedCard",
  componentId: "m8eul1-1"
})(["display:flex;align-items:center;width:100%;min-height:55px;max-height:55px;padding:0 30px;border-bottom:1px solid ", ";"], GREAT_WHITE);
const CollapseButton = styled(SkeletonBox).withConfig({
  displayName: "ContactSidebarPlaceholder__CollapseButton",
  componentId: "m8eul1-2"
})(["margin-top:16px;margin-left:auto;margin-right:auto;"]);
const CollapsedAvatar = styled(SkeletonCircle).withConfig({
  displayName: "ContactSidebarPlaceholder__CollapsedAvatar",
  componentId: "m8eul1-3"
})(["margin-top:24px;margin-left:auto;margin-right:auto;"]);
const DisplayLocked = styled(SkeletonContainer).withConfig({
  displayName: "ContactSidebarPlaceholder__DisplayLocked",
  componentId: "m8eul1-4"
})(["width:100%;@media (max-width:", "px){display:none;}"], CRM_BREAK_POINT);
const DisplayCollapsed = styled(SkeletonContainer).withConfig({
  displayName: "ContactSidebarPlaceholder__DisplayCollapsed",
  componentId: "m8eul1-5"
})(["@media (min-width:", "px){display:none;}"], CRM_BREAK_POINT);
export default class ContactSidebarPlaceholder extends PureComponent {
  renderCollapsed() {
    return /*#__PURE__*/_jsxs(DisplayCollapsed, {
      width: CRM_COLLAPSED_WIDTH,
      "data-test-id": "contact-sidebar-placeholder-collapsed",
      children: [/*#__PURE__*/_jsx(CollapseButton, {
        height: "1.5em",
        width: "1.5em"
      }), /*#__PURE__*/_jsx(CollapsedAvatar, {
        size: 32
      })]
    });
  }
  render() {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.renderCollapsed(), /*#__PURE__*/_jsxs(DisplayLocked, {
        "data-test-id": "contact-sidebar-placeholder",
        children: [/*#__PURE__*/_jsxs(CrmHeader, {
          children: [/*#__PURE__*/_jsx(SkeletonCircle, {
            size: 48,
            className: "m-right-3"
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(SkeletonText, {
              width: "100px"
            }), /*#__PURE__*/_jsx(SkeletonText, {
              width: "140px"
            })]
          })]
        }), /*#__PURE__*/_jsx(CollapsedCard, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "90%"
          })
        }), /*#__PURE__*/_jsx(CollapsedCard, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "70%"
          })
        }), /*#__PURE__*/_jsx(CollapsedCard, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "60%"
          })
        }), /*#__PURE__*/_jsx(CollapsedCard, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "80%"
          })
        }), /*#__PURE__*/_jsx(CollapsedCard, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "60%"
          })
        })]
      })]
    });
  }
}
ContactSidebarPlaceholder.displayName = 'ContactSidebarPlaceholder';